import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { ROUTE_EDIT_USER_SETTING, ROUTE_USER_SETTINGS, ROUTE_WELCOME } from "../../../../routes/Routes";
import PutPostPatchFetch from "../../../../hooks/PutPostPatchFetch";
import usePageTitle from "../../../../hooks/usePageTitle";
import GeneralFormConfig from "../../../../GeneralFormConfig/GeneralFormConfig";
import { fieldTypeNames } from "../../../../BuildingsPage/Shared/shared";
import { showNotification } from "../../../../util/_helpers";
import "./UpdateUserSetting.scss";


const UpdateUserSetting = () => {
    const { title } = ROUTE_EDIT_USER_SETTING;
    usePageTitle(title);

    const { state } = useLocation();
    const userSettings = Object.fromEntries( Object.entries(state) );

    const navigate = useNavigate();
    const validationGroupRef = useRef(null);

    const [formData, setFormData] = useState(userSettings);
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);

    const onFormSubmission = async () => {
        if (!validationGroupRef.current) {
            console.error("ValidationGroup ref is not set");
            return;
        };

        const validationResult = validationGroupRef.current.instance().validate();
        if (!validationResult.isValid) {
            showNotification(
                "Please add values for all required fields and try again.",
                false,
                5000,
                500
            );
            return;
        };

        try {
            setLoading(true);
            const { Errors, Message, Success} = await PutPostPatchFetch(
                "/v1/UserSettings/UpdateUserSettings",
                "POST",
                {
                    "Id": formData.Id,
                    "UserId": formData.UserId,
                    "UserEmail": formData.UserEmail,
                    "UserRole": formData.UserRole,
                    "UserStatus": formData.UserStatus,
                    "Regions": formData.Regions,
                    "SettingName": formData.SettingName,
                    "SettingValue": formData.SettingValue,
                    "CreatedDate": formData.CreatedDate,
                    "CreatedBy": formData.CreatedBy,
                    "UpdatedDate": formData.UpdatedDate,
                    "UpdatedBy": formData.UpdatedBy
                }
            );

            if (Success) {
                showNotification(
                    `User Setting ${formData.UserId} saved, successfully.`,
                    true,
                    5000,
                    500
                );
            };

            if (Errors.length > 0) {
                console.error(Errors)
                showNotification(
                    `User Setting ${formData.UserId} was not successful in saving. \nReason: ${save.Errors[0].Message}`,
                    false,
                    5000,
                    500
                )
            };
            
            setLoading(false);
            setEditing(false);
        } catch (error) {
            showNotification(
                `Your update cannot be saved at this. \nReason: ${error}`,
                false,
                5000,
                500
            );
            setEditing(true);
        }
    };

    const generalFormProps = {
        className: classNames(
            { 
                'plain-styled-form': true, 
                // 'view-mode': !editing 
            }
        ),
        groupedFields: [
            {
                groupCaption: "User Settings",
                fields: [
                    {
                        fieldType: fieldTypeNames.textBox,
                        onValueChanged: (e) => {
                            setFormData({ 
                                ...formData,
                                SettingName: e.value
                            })
                        },
                        readOnly: !editing,
                        // requiredRuleEnabled: true,
                        // requiredRuleMessage: "This field is required",
                        // stringLengthRuleEnabled: true,
                        // stringMaxLength: 1,
                        // stringMinLength: ,
                        // stringLengthRuleMessage: "Value must have one or more characters",
                        value: formData.SettingName,
                        label: "Setting Name"
                    },
                    {
                        fieldType: fieldTypeNames.textBox,
                        onValueChanged: (e) => {
                            setFormData({
                                ...formData,
                                SettingValue: e.value
                            })
                        },
                        readOnly: !editing,
                        // requiredRuleEnabled: true,
                        // requiredRuleMessage: "This field is required",
                        // stringLengthRuleEnabled: true,
                        // stringMaxLength: 1,
                        // stringMinLength: ,
                        // stringLengthRuleMessage: "Value must have one or more characters",
                        value: formData.SettingValue,
                        label: "Setting Value"
                    },
                    {
                        fieldType: fieldTypeNames.textBox,
                        onValueChanged: (e) => {
                            setFormData({
                                ...formData,
                                SettingValue: e.value
                            })
                        },
                        value: formData.Regions,
                        readOnly: true,
                        label: "Regions"
                    },
                    {
                        fieldType: fieldTypeNames.textBox,
                        readOnly: true,
                        value: formData.UpdatedBy,
                        label: "Updated By"
                    },
                    {
                        fieldType: fieldTypeNames.textBox,
                        readOnly: true,
                        value: formData.UpdatedDate,
                        label: "Updated Date"
                    },
                ]
            },
        ],
        loadingIndicatorState: loading,
        loadingIndicatorMessage: "Saving your updates...",
        state: state,
        stringLengthRuleEnabled: true,
        stringLengthRuleMessage: "Value must have one or more characters",
        stringMinLength: 1,
        title: title,
        toolbarConfiguration: {
            children: undefined,
            editing: editing,
            onBackClick: () => navigate(ROUTE_USER_SETTINGS.withSlash),
            onCancelClick: () => navigate(ROUTE_WELCOME.withSlash),
            onSaveClick: onFormSubmission,
            toggleEditing: () => setEditing(prev => !prev)
        },
        validationGroupRef: validationGroupRef
    };

    return <GeneralFormConfig { ...generalFormProps } />;
};

export default UpdateUserSetting; 